export default "__VITE_ASSET__b43442b8__"